import { selectors } from './constants';
import filterActiveCompleteSteps from './filterActiveCompleteSteps';

/**
 * Gets all fields in an element (eg. form or panel) with the specified name attribute,
 * ignoring fields in inactive and incomplete panels.
 *
 * @param {Element} element - The form or panel to look for fields inside
 * @param {Element} name
 */
export default function getFieldsByName(element, name) {
  if (!element || !name) return [];
  let fieldSelectors = selectors.fields.map(tagname => `${tagname}[name="${name}"]`);

  return filterActiveCompleteSteps(
    Array.from(element.querySelectorAll(fieldSelectors.join())),
    element
  );
}
